import script from "./owner-info-page.vue?vue&type=script&setup=true&lang=js"
export * from "./owner-info-page.vue?vue&type=script&setup=true&lang=js"

import "./owner-info-page.vue?vue&type=style&index=0&id=67efbd91&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67efbd91"]])

export default __exports__